import { render, staticRenderFns } from "./PersonhistTable.vue?vue&type=template&id=5e36cf5a&scoped=true&"
import script from "./PersonhistTable.vue?vue&type=script&lang=js&"
export * from "./PersonhistTable.vue?vue&type=script&lang=js&"
import style0 from "./PersonhistTable.vue?vue&type=style&index=0&id=5e36cf5a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e36cf5a",
  null
  
)

export default component.exports